module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-411x93@2x.75c547e1.jpg";